// Centralized Unix-epoch-nanosecond conversions. Aggregate buckets and query
// bounds are carried as ns ints throughout the metrics domain; these helpers
// are the single place we drop to JS `Date` (millisecond) precision. Precision
// below 1ms is irrelevant for the day/week/month bucket edges we display.

/** Nanoseconds → milliseconds. */
export function nsToMs(ns: number): number {
  return ns / 1_000_000;
}

/** Nanoseconds → ISO-8601 UTC string. Bridges aggregate ns to the ISO-string
 *  contract of `getDrillDownTitle`. */
export function nsToIso(ns: number): string {
  return new Date(nsToMs(ns)).toISOString();
}

/** Nanoseconds → short ISO date (`YYYY-MM-DD`), used for chart x-axis labels. */
export function nsToDateLabel(ns: number): string {
  return nsToIso(ns).slice(0, 10);
}
